import styled, { css } from 'styled-components';
import { media } from '../../styles/breakpoints';

export const Bar = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: none;
  height: 30px;
  background: ${props =>
    props.theme.mode === 'dark'
      ? 'rgba(42, 42, 42, 0.95)'
      : 'rgba(255, 255, 255, 0.95)'};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-top: 1px solid ${props =>
    props.theme.mode === 'dark'
      ? 'rgba(255,255,255,0.07)'
      : 'rgba(0,0,0,0.07)'};
  z-index: 950;
  align-items: center;
  justify-content: space-around;
  padding: 0 8px;

  @media (max-width: 723px) {
    display: flex;
  }

  ${media.mobile724} {
    display: none !important;
  }

  ${media.laptop} {
    display: none !important;
  }
`;

export const Btn = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 26px;
  border-radius: 6px;
  position: relative;
  color: ${props =>
    props.$active ? props.theme.colors.primary : props.theme.colors.iconColor};
  opacity: ${props => (props.$active ? 1 : 0.65)};
  transition: color 0.15s ease, opacity 0.15s ease, background 0.15s ease;

  &:hover {
    opacity: 1;
    background: ${props =>
      props.theme.mode === 'dark'
        ? 'rgba(255,255,255,0.06)'
        : 'rgba(0,0,0,0.05)'};
  }

  &:active {
    transform: scale(0.92);
  }

  ${props =>
    props.$active &&
    css`
      &::after {
        content: '';
        position: absolute;
        bottom: 3px;
        left: 50%;
        transform: translateX(-50%);
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: ${props.theme.colors.primary};
      }
    `}

  svg {
    width: 14px;
    height: 14px;
    stroke-width: 1.8px;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 940;
  background: rgba(0, 0, 0, 0.35);
`;

export const Panel = styled.div<{ $open: boolean }>`
  position: fixed;
  bottom: 30px;
  left: 0;
  right: 0;
  z-index: 945;
  background: ${props =>
    props.theme.mode === 'dark' ? '#2A2A2A' : '#FFFFFF'};
  border-top: 1px solid ${props =>
    props.theme.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'};
  border-radius: 14px 14px 0 0;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  max-height: 72vh;
  overflow: hidden;
  transform: translateY(${props => (props.$open ? '0' : '100%')});
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);

  @media (min-width: 724px) {
    display: none;
  }
`;

export const PanelHandle = styled.div`
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: ${props =>
    props.theme.mode === 'dark' ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.15)'};
  margin: 10px auto 6px;
  flex-shrink: 0;
`;

export const PanelTitle = styled.h3`
  margin: 0;
  padding: 8px 16px 10px;
  font-size: 0.9rem;
  font-weight: 700;
  color: ${props => props.theme.colors.text};
  border-bottom: 1px solid ${props =>
    props.theme.mode === 'dark' ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.07)'};
  flex-shrink: 0;
`;

export const PanelBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
  color: ${props => props.theme.colors.text};

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.scrollThumb};
    border-radius: 2px;
  }
`;

export const SearchRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const SearchInputStyled = styled.input`
  flex: 1;
  height: 38px;
  border: 1px solid ${props => props.theme.colors.inputBorder};
  border-radius: 8px;
  padding: 0 12px;
  font-size: 0.9rem;
  background: ${props => props.theme.colors.searchInputBackground};
  color: ${props => props.theme.colors.text};
  outline: none;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
  }
`;

export const SearchBtn = styled.button`
  height: 38px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  background: ${props => props.theme.colors.primary};
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
`;

export const FilterSectionLabel = styled.p`
  font-size: 0.78rem;
  font-weight: 700;
  color: ${props => props.theme.colors.iconColor};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 14px 0 8px;

  &:first-child { margin-top: 0; }
`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  font-size: 0.88rem;
  color: ${props => props.theme.colors.text};
  cursor: pointer;

  input[type='checkbox'] {
    accent-color: ${props => props.theme.colors.primary};
    width: 15px;
    height: 15px;
  }
`;

export const FilterFooter = styled.div`
  padding: 10px 16px;
  border-top: 1px solid ${props =>
    props.theme.mode === 'dark' ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.07)'};
  display: flex;
  gap: 8px;
  flex-shrink: 0;
`;

export const ApplyBtn = styled.button`
  flex: 1;
  height: 38px;
  border: none;
  border-radius: 8px;
  background: ${props => props.theme.colors.primary};
  color: #fff;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
`;

export const ClearBtn = styled.button`
  height: 38px;
  padding: 0 14px;
  border: 1px solid ${props => props.theme.colors.inputBorder};
  border-radius: 8px;
  background: none;
  color: ${props => props.theme.colors.text};
  font-size: 0.88rem;
  cursor: pointer;
`;
